export const PRICE_LOW = '1'
export const PRICE_MIDDLE = '2'
export const PRICE_HIGH = '3'

export const priceFieldName = id => `price_${id}`

export const ICON_DISABLED_PEOPLE = '2'
export const ICON_PETS_ALLOWED = '3'
export const ICON_PARKING = '4'
export const ICON_POOL = '5'
export const ICON_SPORTS_HALL = '6'
export const ICON_MEETING_ROOM = '7'
export const ICON_AIR_CONDITIONER = '8'

export const amenityFieldName = id => `amenity_${id}`

export const ICON_BUSINESS = '1'
export const ICON_FAMILY = '2'

export const hotelTypeFieldName = id => `hotelType_${id}`
